import React, { useEffect, useState } from "react";
import styled from "styled-components";

const QuizFeed = ({
  quiz,
  quizResult,
  setQuizResult,
  quizIndex,
  nextBtn,
  addPlus,
  modalOn,
  setModalOn,
  resultFilter,
}) => {
  const { quiz_id, question, image_url, choice } = quiz;
  const [currentChoiceId, setCurrentChoiceId] = useState(0);

  const goToNext = () => {
    if (quizIndex < 0 || quizIndex > 3) {
      return;
    }
    nextBtn();
    addPlus();
  };

  useEffect(() => {
    quizResult?.map(test => {
      if (test.quiz_id === quiz.quiz_id) {
        const currentChoiceIdForCopy = test.choice_id;
        setCurrentChoiceId(currentChoiceIdForCopy);
      }
    });
  }, [quizResult, quizIndex]);

  const clickAnswer = e => {
    quizResult[quizIndex].choice_id = Number(e.target.id);
    setQuizResult([...quizResult]);
    goToNext();
    if (quizIndex === 4 && resultFilter.length === 0) {
      setModalOn(current => !current);
    }
  };

  return (
    <QuizFeedCtn>
      <QuizClass>{quizIndex + 1}교시</QuizClass>
      <QuizFeedMain>
        <QuizPicBox>
          {image_url && <QuizPic src={image_url} alt="퀴즈이미지" />}
        </QuizPicBox>
        <QuizQuestion>{question}</QuizQuestion>
      </QuizFeedMain>

      <QuizAnswer>
        <AnswerUp>
          <Answer
            id={choice[0].choice_id}
            onClick={clickAnswer}
            isChoiced={choice[0].choice_id === currentChoiceId}
          >
            {choice[0].content}
          </Answer>
          <Answer
            id={choice[1].choice_id}
            onClick={clickAnswer}
            isChoiced={choice[1].choice_id === currentChoiceId}
          >
            {choice[1].content}
          </Answer>
        </AnswerUp>
        <AnswerDown>
          <Answer
            id={choice[2].choice_id}
            onClick={clickAnswer}
            isChoiced={choice[2].choice_id === currentChoiceId}
          >
            {choice[2].content}
          </Answer>
          <Answer
            id={choice[3].choice_id}
            onClick={clickAnswer}
            isChoiced={choice[3].choice_id === currentChoiceId}
          >
            {choice[3].content}
          </Answer>
        </AnswerDown>
      </QuizAnswer>
    </QuizFeedCtn>
  );
};

export default QuizFeed;

const QuizFeedCtn = styled.div`
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
  @media screen and (max-width: 700px) {
    font-size: 12px;
  }
  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
  @media screen and (max-width: 300px) {
    font-size: 8px;
  }
`;

const QuizClass = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  width: 20%;
  height: 2em;
  margin: 2em auto;
  border: 1px solid black;
  border-radius: 5em;
  font-size: 1.5em;
  text-align: center;
`;

const QuizFeedMain = styled.div`
  text-align: center;
`;

const QuizPicBox = styled.div`
  width: 50%;
  height: 20%;
  margin-top: 100px;
  margin: 0 auto;
`;

const QuizPic = styled.img`
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
`;

const QuizQuestion = styled.p`
  width: 100%;
  margin: 2em auto;
  font-size: 2em;
  color: #222;
  font-weight: 700;
`;

const QuizAnswer = styled.div``;

const Answer = styled.button`
  ${props => props.theme.variables.flex("", "center", "center")}
  background-color: ${props => (props.isChoiced ? "#F11A26" : "#ececec")};
  color: ${props => (props.isChoiced ? "#ffffff" : "#000000")};
  width: 50%;
  height: 5em;
  margin: 0 0.3em;
  outline: none;
  border: 1px solid #c8c8c8;
  text-align: center;
  border-radius: 10px;
  box-shadow: 5px 5px 2px 1px rgba(0, 0, 0, 0.1);
  font-size: 2em;
`;

const AnswerUp = styled.div`
  ${props => props.theme.variables.flex("", "space-evenly", "center")}
`;
const AnswerDown = styled.div`
  ${props => props.theme.variables.flex("", "space-evenly", "center")}
  margin-top: 2em;
`;
